import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';
import { MdmAvailableOsUpdatesStoreActions, MdmAvailableOsUpdatesStoreStates } from '../mdm-available-os-updates';
import { DevicesRouterStoreSelectors, RouterStoreStates } from '../router';

@Injectable()
export class MdmAvailableOsUpdatesResolver {
  constructor(
    private readonly routerStore: Store<RouterStoreStates.RouterState>,
    private readonly mdmAvailableOsUpdatesStore: Store<MdmAvailableOsUpdatesStoreStates.MdmAvailableOsUpdatesState>
  ) {}

  resolve(): Observable<boolean> {
    return this.routerStore.select(DevicesRouterStoreSelectors.selectUdid).pipe(
      tap((udid) => {
        this.mdmAvailableOsUpdatesStore.dispatch(
          MdmAvailableOsUpdatesStoreActions.MdmAvailableOsUpdatesResolverActions.availableOSUpdatesRequested({
            udid,
          })
        );
      }),
      map(() => true),
      first()
    );
  }
}
